import React from 'react';
import PropTypes from 'prop-types';
import * as S from './HeroSection.Style';

const HeroSection = ({ backgroundImageDesktop, backgroundImageMobile, primarySubtitle, mainTitle, secondaryTitle }) => {
  return (
    <S.Hero backgroundImageDesktop={backgroundImageDesktop} backgroundImageMobile={backgroundImageMobile}>
      <S.Content>
        {primarySubtitle && <S.PrimarySubtitle>{primarySubtitle}</S.PrimarySubtitle>}
        <S.MainTitle>{mainTitle}</S.MainTitle>
        {secondaryTitle && <S.SecondSubtitle>{secondaryTitle}</S.SecondSubtitle>}
      </S.Content>
    </S.Hero>
  );
};

HeroSection.propTypes  = {
  backgroundImageDesktop: PropTypes.string.isRequired,
  backgroundImageMobile: PropTypes.string.isRequired,
  primarySubtitle: PropTypes.string,
  mainTitle: PropTypes.string.isRequired,
  secondaryTitle: PropTypes.string
}

HeroSection.defaultProps = {
  primarySubtitle: '',
  secondaryTitle: ''
};

export default HeroSection;